import React, { useState } from "react";
import { Box, Paper, Tab, Tabs, TextField, Typography } from "@mui/material";
import ButtonCommon from "../CommonComponents/ButtonCommon";
import { showErrorToast, showSuccessToast } from "../toastUtils";
import axios from "axios";
import { ReactComponent as ToolsIcon } from "../static/Icons/tools.svg";
import { ReactComponent as ActionsIcon } from "../static/Icons/actions.svg";
import { ReactComponent as TestIcon } from "../static/Icons/test.svg";

export default function Test({ serverDetails }) {
  const [showActions, setShowActions] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const [showRunTool, setShowRunTool] = useState(false);
  const [showOutput, setShowOutput] = useState(false);
  const [tools, setTools] = useState([]);
  const [formValues, setFormValues] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [outputData, setOutputData] = useState(null);
  const [serverURL, setServerURL] = useState("");
  const [selectedTab, setSelectedTab] = useState(0);

  const handleChange = (param, value) => {
    setFormValues((prev) => ({ ...prev, [param]: value }));
    setFormErrors((prev) => ({ ...prev, [param]: undefined }));
  };

  const handleRunTool = async () => {
    const errors = {};

    Object.entries(actionNeeds || {}).forEach(([key, field]) => {
      if (field.required && !formValues[field.param]?.trim()) {
        errors[field.param] = `${field.param} is required`;
      }
    });

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }

    // ✅ All validations passed
    const payload = {
      method: "tools/call",
      params: {
        name: selectedAction,
        arguments: {
          ...formValues, // All dynamic input values here
        },
        _meta: {
          progressToken: 0,
        },
      },
    };

    try {
      const response = await axios.post(serverURL, payload, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: false,
        timeout: 10000
      });
      if (response.error) {
        showErrorToast(response.error.message);
      } else {
        setOutputData(response.data);
        setShowOutput(true); // Show output UI
      }
    } catch (error) {
      console.error("API Error:", error);
    }
  };

  // const selectedToolData = serverDetails.actions.find(
  //   (tool) => tool.toolName === selectedTool
  // );

  const selectedActionData = serverDetails.actions
    .flatMap((tool) => tool.toolActions)
    .find((action) => action.actionName === selectedAction);

  const actionNeeds = selectedActionData?.actionNeeds;

  // const fetchServerSecrets = async () => {
  //   try {
  //     const res = await getServerSecrets();
  //     if (res.success) {
  //       setServerSecrets(res.data.server_secrets);
  //     } else {
  //       showErrorToast(res.message);
  //     }
  //   } catch (error) {
  //     showErrorToast(error.message);
  //   }
  // };

  // useEffect(() => {
  //   fetchServerSecrets();
  // }, []);

  // console.log(serverSecrets, "serverSecrets");

  const getListTools = async () => {
    console.log("Making tools/list API call to:", serverURL);
    
    try {
      const response = await axios.post(
        serverURL,
        {
          method: "tools/list",
          params: {},
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: false,
          timeout: 10000
        }
      );
      
      console.log("Tools/list response:", response);
      
      if (response.status === 200 && response.data?.result?.tools) {
        console.log("Tools received:", response.data.result.tools);
        setTools(response.data.result.tools);
        setShowActions(true);
      } else {
        console.error("Invalid tools response:", response.data);
        showErrorToast("Failed to get tools list - Invalid response format");
      }
    } catch (error) {
      console.error("Get tools error:", error);
      console.error("Tools error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      
      if (error.response) {
        showErrorToast(`Tools error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
      } else if (error.request) {
        showErrorToast("Network error: Unable to get tools list");
      } else {
        showErrorToast(`Tools error: ${error.message}`);
      }
    }
  };

  const handleBindServer = async () => {
    // Validate server URL
    if (!serverURL || !serverURL.trim()) {
      showErrorToast("Please enter a server URL");
      return;
    }

    // Basic URL validation
    try {
      new URL(serverURL);
    } catch (urlError) {
      showErrorToast("Please enter a valid URL (e.g., http://localhost:3000)");
      return;
    }

    console.log("Attempting to bind server:", serverURL);
    
    try {
      console.log("Making initialize API call to:", serverURL);
      const response = await axios.post(
        serverURL,
        {
          method: "initialize",
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
          withCredentials: false,
          timeout: 10000
        }
      );
      
      console.log("Initialize response:", response);
      
      if (response?.data?.result?.serverInfo) {
        console.log("Server info received, calling getListTools");
        await getListTools();
        showSuccessToast("Server Bind Successfully!");
      } else {
        console.error("Invalid response structure:", response?.data);
        showErrorToast("Failed to Bind Server - Invalid response format");
      }
    } catch (error) {
      console.error("Bind server error:", error);
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      });
      
      if (error.response) {
        showErrorToast(`Server error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
      } else if (error.request) {
        showErrorToast("Network error: Unable to connect to server. Check if server is running and URL is correct.");
      } else {
        showErrorToast(`Error: ${error.message}`);
      }
    }
  };

  const tabData = [
    { label: "Tools", icon: ToolsIcon },
    { label: "Resources", icon: ActionsIcon },
    { label: "Prompts", icon: TestIcon },
  ];

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <Paper
      sx={{
        p: { xs: 1.5, sm: 2, md: 3 },
        bgcolor: "#D4E6FF17",
        color: "white",
        borderRadius: 2,
        height: "100%",
        overflow: "auto",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
          display: "none",
        },
        "-ms-overflow-style": "none",
      }}
    >
      <Box>
        {/* Server URL Input */}
        <Box
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={2}
          mb={2}
        >
          <Typography
            sx={{
              color: "white",
              whiteSpace: { xs: "normal", sm: "nowrap" },
              fontSize: { xs: "0.875rem", sm: "1rem" },
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            Server URL:
          </Typography>

          <TextField
            variant="outlined"
            fullWidth
            value={serverURL}
            placeholder="Enter MCP server URL (e.g., http://localhost:3000)"
            sx={{
              maxWidth: { xs: "100%", sm: "none" },
              input: {
                color: "white",
                fontSize: { xs: "0.875rem", sm: "1rem" },
              },
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "lightgray",
                },
                "&:hover fieldset": {
                  borderColor: "lightgray",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "lightgray",
                },
              },
            }}
            onChange={(event) => setServerURL(event.target.value)}
            size="small"
          />

          <ButtonCommon
            sx={{
              width: { xs: "100%", sm: "35%", md: "200px" },
              height: "40px",
              fontSize: { xs: "0.875rem", sm: "1rem" },
              minWidth: { xs: "auto", sm: "120px" },
            }}
            onClick={handleBindServer}
          >
            Bind Server
          </ButtonCommon>
        </Box>

        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          textColor="inherit"
          indicatorColor="primary"
          // variant="scrollable"
          // scrollButtons="auto"
          sx={{
            width: { xs: "100%", md: "auto" },
            maxWidth: "100%",
            height: { xs: "auto", md: "60px" },
            // minHeight: { xs: "48px", md: "60px" },
            overflowX: "auto",
            scrollbarWidth: "none",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            "-ms-overflow-style": "none",
            "& .MuiTab-root": {
              minWidth: "auto",
              flexShrink: 1,
              whiteSpace: "nowrap",
              fontSize: { xs: "0.75rem", sm: "0.875rem" },
              // padding: { xs: "6px 8px", sm: "12px 16px" },
            },
          }}
        >
          {tabData.map((tab, index) => {
            const IconComponent = tab.icon;
            const isSelected = selectedTab === index;

            return (
              <Tab
                key={index}
                label={tab.label}
                icon={
                  <IconComponent
                    style={{
                      color: isSelected ? "#B9E307" : "white",
                      width: 24,
                      height: 24,
                    }}
                  />
                }
                iconPosition="start"
                sx={{
                  color: isSelected ? "#B9E307" : "white",
                  fontWeight: isSelected ? "bold" : "normal",
                  flexDirection: { xs: "column", sm: "row" },
                }}
              />
            );
          })}
        </Tabs>

        {selectedTab === 0 && (
          <>
            {/* Actions Layout */}
            {showActions && (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  gap: { xs: 2, md: 3 },
                  width: "100%",
                  minHeight: { xs: "auto", lg: "400px" },
                }}
              >
                {/* Left Side - Tools Actions */}
                <Box
                  sx={{
                    mt: 3,
                    p: { xs: 2, sm: 3 },
                    borderRadius: 2,
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    width: {
                      xs: "100%",
                      lg: showRunTool ? "50%" : "100%",
                    },
                    border: "1.39px solid #FFFFFF33",
                    minHeight: { xs: "300px", lg: "400px" },
                    transition: "width 0.3s ease",
                  }}
                >
                  <Typography
                    color="#fff"
                    fontWeight={700}
                    variant="h6"
                    mb={1}
                    sx={{
                      fontSize: { xs: "1.1rem", sm: "1.25rem" },
                      textAlign: { xs: "center", sm: "left" },
                    }}
                  >
                    {selectedTab === 0
                      ? "Tools of Action"
                      : selectedTab === 1
                      ? "Resources"
                      : "Prompts"}
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1.5,
                      flex: 1,
                      maxHeight: { xs: "40vh", sm: "350px" },
                      overflow: "auto",
                      scrollbarWidth: "none",
                      "&::-webkit-scrollbar": {
                        display: "none",
                      },
                      "-ms-overflow-style": "none",
                    }}
                  >
                    {tools.map((action) => (
                      <Box
                        key={action.actionId}
                        sx={{
                          p: { xs: 1.5, sm: 2 },
                          width: "100%",
                          display: "flex",
                          alignItems: "flex-start",
                          gap: { xs: 1, sm: 1.5 },
                          border: "1px solid #FFFFFF33",
                          background: "#2C2F3366",
                          borderRadius: 2,
                          cursor: "pointer",
                          transition: "all 0.2s ease",
                          "&:hover": {
                            borderColor: "#FFFFFF66",
                            backgroundColor: "#2C2F3388",
                          },
                          ...(selectedAction === action.name && {
                            borderColor: "#FFFFFF",
                            backgroundColor: "#2C2F33AA",
                          }),
                        }}
                        onClick={() => {
                          setSelectedAction(action.name);
                          setShowRunTool(true);
                          setShowOutput(false);
                          setFormValues({});
                        }}
                      >
                        <Box
                          sx={{
                            width: 4,
                            height: "100%",
                            minHeight: 40,
                            bgcolor: selectedAction === action.name ? "#B9E307" : "#FFFFFF33",
                            borderRadius: 1,
                            transition: "all 0.2s ease",
                          }}
                        />
                        <Box 
                          display="flex" 
                          flexDirection="column" 
                          flex={1}
                          sx={{ pt: 0.25 }}
                        >
                          <Typography
                            color="#fff"
                            variant="body1"
                            fontWeight={600}
                            sx={{
                              fontSize: { xs: "0.875rem", sm: "1rem" },
                              lineHeight: 1.3,
                              wordBreak: "break-word",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: 2,
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {action.name}
                          </Typography>
                          <Typography
                            color="#BBBBBB"
                            variant="body2"
                            sx={{
                              fontSize: { xs: "0.75rem", sm: "0.875rem" },
                              lineHeight: 1.3,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              display: "-webkit-box",
                              WebkitLineClamp: { xs: 2, sm: 3 },
                              WebkitBoxOrient: "vertical",
                            }}
                          >
                            {action.description}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>

                {/* Right Side - Run Tool Form */}
                {showRunTool && (
                  <Box
                    sx={{
                      mt: 3,
                      p: { xs: 2, sm: 3 },
                      borderRadius: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: 2,
                      width: { xs: "100%", lg: "50%" },
                      border: "1.39px solid #FFFFFF33",
                      minHeight: { xs: "300px", lg: "400px" },
                      maxHeight: { xs: "40vh", sm: "400px" },
                    }}
                  >
                    <Typography
                      color="#fff"
                      fontWeight={700}
                      variant="h6"
                      mb={1}
                      sx={{
                        fontSize: { xs: "1.1rem", sm: "1.25rem" },
                        textAlign: { xs: "center", sm: "left" },
                        wordBreak: "break-word",
                      }}
                    >
                      Run{" "}
                      {selectedTab === 0
                        ? "Tool"
                        : selectedTab === 1
                        ? "Resource"
                        : "Prompt"}
                      : {selectedAction}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2,
                        flex: 1,
                        overflow: "auto",
                        scrollbarWidth: "none",
                        "&::-webkit-scrollbar": {
                          display: "none",
                        },
                        "-ms-overflow-style": "none",
                      }}
                    >
                      {actionNeeds &&
                        Object.entries(actionNeeds).map(([key, field]) => (
                          <Box key={key}>
                            <Typography
                              color="#fff"
                              fontWeight={600}
                              mb={0.5}
                              sx={{
                                fontSize: { xs: "0.875rem", sm: "1rem" },
                                wordBreak: "break-word",
                              }}
                            >
                              {field.param}
                              {field.required && (
                                <span style={{ color: "#ff6b6b" }}> *</span>
                              )}
                            </Typography>

                            {field.helpText && (
                              <Typography
                                variant="body2"
                                color="#FFFFFF99"
                                mb={1}
                                sx={{
                                  fontSize: { xs: "0.75rem", sm: "0.875rem" },
                                  lineHeight: 1.4,
                                  wordBreak: "break-word",
                                }}
                              >
                                {field.helpText}
                              </Typography>
                            )}

                            <TextField
                              fullWidth
                              variant="outlined"
                              size="small"
                              name={field.param}
                              value={formValues[field.param] || ""}
                              onChange={(e) =>
                                handleChange(field.param, e.target.value)
                              }
                              placeholder={`Enter ${field.param}`}
                              error={Boolean(formErrors[field.param])}
                              helperText={formErrors[field.param]}
                              InputLabelProps={{ shrink: true }}
                              multiline={
                                field.param
                                  .toLowerCase()
                                  .includes("description") ||
                                field.param.toLowerCase().includes("content")
                              }
                              rows={
                                field.param
                                  .toLowerCase()
                                  .includes("description") ||
                                field.param.toLowerCase().includes("content")
                                  ? 3
                                  : 1
                              }
                              sx={{
                                "& .MuiInputBase-input": {
                                  color: "#fff",
                                  fontSize: { xs: "0.875rem", sm: "1rem" },
                                },
                                "& .MuiOutlinedInput-root": {
                                  "& fieldset": {
                                    borderColor: "#ffffff33",
                                    borderRadius: 1,
                                  },
                                  "&:hover fieldset": {
                                    borderColor: "#ffffff66",
                                  },
                                  "&.Mui-focused fieldset": {
                                    borderColor: "#ffffff",
                                  },
                                },
                                "& .MuiInputBase-root": {
                                  backgroundColor: "#FFFFFF08",
                                },
                                "& .MuiFormHelperText-root": {
                                  fontSize: { xs: "0.7rem", sm: "0.75rem" },
                                },
                              }}
                            />
                          </Box>
                        ))}
                    </Box>

                    <Box sx={{ mt: "auto", pt: 2 }}>
                      <ButtonCommon
                        variant="contained"
                        fullWidth
                        onClick={handleRunTool}
                        sx={{
                          py: { xs: 1.2, sm: 1.5 },
                          fontSize: { xs: "0.875rem", sm: "1rem" },
                          fontWeight: 600,
                        }}
                      >
                        Run{" "}
                        {selectedTab === 0
                          ? "Tool"
                          : selectedTab === 1
                          ? "Resource"
                          : "Prompt"}
                      </ButtonCommon>
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            {/* Output Section */}
            {showOutput && (
              <Box
                sx={{
                  mt: 3,
                  p: { xs: 2, sm: 3 },
                  borderRadius: 2,
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  width: "100%",
                  border: "1.39px solid #FFFFFF33",
                  backgroundColor: "#FFFFFF05",
                }}
              >
                <Typography
                  color="#fff"
                  fontWeight={700}
                  variant="h6"
                  sx={{
                    fontSize: { xs: "1.1rem", sm: "1.25rem" },
                    textAlign: { xs: "center", sm: "left" },
                  }}
                >
                  Output
                </Typography>
                <Box
                  p={{ xs: 1.5, sm: 2 }}
                  sx={{
                    backgroundColor: "#1e1e1e",
                    color: "#fff",
                    borderRadius: 2,
                    fontFamily: "monospace",
                    fontSize: { xs: "0.75rem", sm: "0.875rem" },
                    whiteSpace: "pre-wrap",
                    overflowX: "auto",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                      display: "none",
                    },
                    "-ms-overflow-style": "none",
                    border: "1px solid #ffffff33",
                    maxHeight: { xs: "40vh", sm: "60vh" },
                    overflowY: "auto",
                    wordBreak: "break-all",
                  }}
                >
                  {JSON.stringify(outputData, null, 2)}
                </Box>
              </Box>
            )}
          </>
        )}

         {selectedTab === 1 &&(
           <Typography
           sx={{
            textAlign:"center",
            p:2,

           }}
           >No Resource Found</Typography>
         )}

         {selectedTab === 2 &&(
          <Typography
           sx={{
            textAlign:"center",
            p:2,

           }}
           >No Prompts Found</Typography>
         )}
      </Box>
    </Paper>
  );
}
